import { createAction } from 'redux-actions';
import {
  CREATE_DESIGN_START,
  CREATE_DESIGN_SUCCESS,
  CREATE_DESIGN_FAILED,
  CREATE_ITEM_PRODUCT_START,
  CREATE_ITEM_PRODUCT_SUCCESS,
  CREATE_ITEM_PRODUCT_FAILED,
  CREATE_CONFIG_START,
  CREATE_CONFIG_SUCCESS,
  CREATE_CONFIG_FAILED,
  CREATE_ITEM_START,
  CREATE_ITEM_SUCCESS,
  CREATE_ITEM_DETAILS_SUCCESS,
  CREATE_ITEM_FAILED,
  REMOVE_ITEM_FROM_DESIGN_START,
  REMOVE_ITEM_FROM_DESIGN_SUCCESS,
  REMOVE_ITEM_FROM_DESIGN_FAILED,
  CREATE_CONTAINER_SUCCESS,
  ALL_DONE,
  VIEW_ACCESSORIES,
  IS_FAILED,
  IS_ATC_START,
} from './actionTypes';

export const createDesignStart = () => (
  createAction(
    CREATE_DESIGN_START,
    () => ({}),
  )
)();

export const createDesignSuccess = design => (
  createAction(
    CREATE_DESIGN_SUCCESS,
    () => ({ design }),
  )
)(design);

export const createDesignFailed = data => (
  createAction(
    CREATE_DESIGN_FAILED,
    () => ({ data }),
  )
)(data);

export const createConfigStart = () => (
  createAction(
    CREATE_CONFIG_START,
    () => ({}),
  )
)();

export const createConfigSuccess = config => (
  createAction(
    CREATE_CONFIG_SUCCESS,
    () => ({ config }),
  )
)(config);

export const createItemProductStart = (...args) => (
  createAction(
    CREATE_ITEM_PRODUCT_START,
    () => ({ ...args }),
  )
)(...args);

export const createItemProductSuccess = ({ item }) => (
  createAction(
    CREATE_ITEM_PRODUCT_SUCCESS,
    () => ({ item }),
  )
)({ item });

export const createItemProductFailed = data => (
  createAction(
    CREATE_ITEM_PRODUCT_FAILED,
    () => (data),
  )
)(data);

export const createItemStart = ({ containerId }) => (
  createAction(
    CREATE_ITEM_START,
    () => ({ containerId }),
  )
)(containerId);

export const createItemSuccess = newItem => (
  createAction(
    CREATE_ITEM_SUCCESS,
    () => (newItem),
  )
)(newItem);

export const createItemDetailsSuccess = itemDetails => (
  createAction(
    CREATE_ITEM_DETAILS_SUCCESS,
    () => (itemDetails),
  )
)(itemDetails);

export const createItemFailed = data => (
  createAction(
    CREATE_ITEM_FAILED,
    () => (data),
  )
)(data);

export const removeItemFromDesignStart = ({ id }) => (
  createAction(
    REMOVE_ITEM_FROM_DESIGN_START,
    () => ({ id }),
  )
)(id);

export const removeItemFromDesignSuccess = ({ id }) => (
  createAction(
    REMOVE_ITEM_FROM_DESIGN_SUCCESS,
    () => ({ id }),
  )
)(id);

export const removeItemFromDesignFailed = data => (
  createAction(
    REMOVE_ITEM_FROM_DESIGN_FAILED,
    () => ({ data }),
  )
)(data);

export const createContainerSuccess = containerId => (
  createAction(
    CREATE_CONTAINER_SUCCESS,
    () => ({ containerId }),
  )
)(containerId);

export const isAllDone = isDone => (
  createAction(
    ALL_DONE,
    () => (isDone),
  )
)(isDone);

export const isAtcStart = isStarted => (
  createAction(
    IS_ATC_START,
    () => (isStarted),
  )
)(isStarted);

export const isFailed = failed => (
  createAction(
    IS_FAILED,
    () => (failed),
  )
)(failed);

export const createConfigurationFailed = data => (
  createAction(
    CREATE_CONFIG_FAILED,
    () => (data),
  )
)(data);

export const isAccessorieVisible = check => (
  createAction(
    VIEW_ACCESSORIES,
    () => (check),
  )
)(check);
